import qs from 'qs'

export const extractStateParameters = location => {
  const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const nonce =
    window.sessionStorage.getItem('nonceOAuth-google') || window.sessionStorage.getItem('nonceOAuth-microsoft')
  const res = {
    error: searchParams.error,
    state: searchParams.state,
    localStateGoogle: window.sessionStorage.getItem('stateOAuth-google'),
    localStateMicrosoft: window.sessionStorage.getItem('stateOAuth-microsoft'),
    code: searchParams.code,
    nonce
  }

  window.sessionStorage.removeItem('stateOAuth-microsoft')
  window.sessionStorage.removeItem('stateOAuth-google')
  window.sessionStorage.removeItem('nonceOAuth-google')
  window.sessionStorage.removeItem('nonceOAuth-microsoft')

  return res
}



// WEBPACK FOOTER //
// ./src/pages/incrementalCallback/utils.js